import moment from "moment";
import { useMediaQuery } from "react-responsive";

import CalendarEvent from "./CalendarEvent";
import CalendarDayMessages from "./CalendarDayMessages";

const CalendarDay = ({ apiKey, date, error, events, setDate, today, showCalendar, setShowCalendar, messages }) => {
	const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });

	const activeMessages = () => {
		if (!messages || !messages.length) return null;

		return messages.filter(({ start_date, end_date }) => {
			const isAfterStart = moment(date).isSameOrAfter(start_date);
			const isBeforeEnd = moment(date).isSameOrBefore(end_date);
			return isAfterStart && isBeforeEnd;
		});
	};

	const isActiveMessages = activeMessages() && activeMessages().length;

	const renderMessages = () => {
		if (isActiveMessages) return <CalendarDayMessages activeMessages={activeMessages()} />;
	}
	const renderEvents = () => {
		const isError = error && !isActiveMessages

		if (isError) return <span className="error">{error}</span>;

		return events.map((event) => <CalendarEvent date={date} key={date} today={today} event={event} apiKey={apiKey} />);
	};

	return (
		<div className="calendar-day">
			<div className="calendar-day__header">
				<div className="arrow--prev" tabIndex={0} aria-label="go to previous day" onClick={() => setDate(moment(date).add(-1, "days").format("YYYY-MM-DD"))} />
				<div className="date" onClick={() => setShowCalendar(!showCalendar)} tabIndex={0}>
					<h2>{isDesktop ? moment(date).format("dddd, MMMM Do") : moment(date).format("ddd, MMM Do")}</h2>
				</div>
				<div className="arrow--next" tabIndex={0} aria-label="go to next day" onClick={() => setDate(moment(date).add(1, "days").format("YYYY-MM-DD"))} />
			</div>
			{renderMessages()}
			{renderEvents()}
		</div>
	);
};

export default CalendarDay;
